export default function fitText(
  ctx: CanvasRenderingContext2D,
  end: number,
  fullText: string,
  maxWidth: number,
  retries = 0,
  previousWidth = null,
) {
  const potentialText = fullText.substr(0, end)
  const { width: potentialWidth } = ctx.measureText(potentialText)
  const roundedWidth = Math.round(potentialWidth)

  if (
    (!previousWidth && roundedWidth <= maxWidth) ||
    (previousWidth && previousWidth > maxWidth && roundedWidth <= maxWidth)
  ) {
    return potentialText
  }
  if (roundedWidth > maxWidth) {
    return fitText(ctx, end - 1, fullText, maxWidth, retries + 1, roundedWidth)
  }

  if (roundedWidth < maxWidth) {
    return fitText(ctx, end + 1, fullText, maxWidth, retries + 1, roundedWidth)
  }
}
